import { useSessionStore } from "features/Session"
import * as React from "react"
import { Redirect, Route, RouteProps } from "react-router-dom"

import { usePackages } from "features/Packages"
import { PackageCode } from "models/generated"
import { APPLICATION_URL } from "./ApplicationNavigation"

export const HomeDisambiguationRoute: React.FunctionComponent<RouteProps> = (props) => {
  const authentication = useSessionStore(state => state.authentication)
  const customer = useSessionStore(state => state.customer)
  const { hasPackage } = usePackages()

  return (
    <Route
      {...props}
      render={() => {
        if (!customer) {
          return <Redirect to={{ pathname: APPLICATION_URL.base() }}/>
        }

        if (!authentication.isAuthenticated) {
          return <Redirect to={{ pathname: APPLICATION_URL.login() }}/>
        }

        return <Redirect to={{ pathname: getHomePage() }}/>
      }}
    />
  )

  function getHomePage() {
    if (hasPackage(PackageCode.Speakup) || !hasPackage(PackageCode.Led)) {
      return APPLICATION_URL.speakupDashboard()
    }

    return APPLICATION_URL.ledStatistics()
  }
}
